/**
 * Accordion Component
 *
 * Sets attribute "aria-expanded" to true/false, which is used
 * in _component-accordion.scss to determine which accordion to display
 */


 var aucor_terms_menu_init = function(menu, i) {
  var menu_item_buttons = menu.querySelectorAll('.js-terms-navigation-toggle');
  menu_item_buttons.forEach(item => {
    let button = item;
    let children = item.parentNode.parentNode.querySelector('ul');

    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-selected', 'false');
    button.setAttribute('aria-controls', 'children-' + i);
    button.setAttribute('type', 'button');

    children.setAttribute('id', 'children-' + i);
    children.setAttribute('aria-hidden', 'true');
    children.setAttribute('aria-labelledby', 'children-' + i);

    button.addEventListener('click', aucor_terms_menu_toggle, false);
  });
};

var aucor_terms_menu_toggle = function(e) {
  e.stopPropagation();

  var button = e.currentTarget;
  var children = e.currentTarget.parentNode.parentNode.querySelector('ul');

  if (button.getAttribute('aria-expanded') === 'true') {
    button.setAttribute('aria-expanded', 'false');
    children.setAttribute('aria-hidden', 'true');
  } else {
    button.setAttribute('aria-expanded', 'true');
    children.setAttribute('aria-hidden', 'false');
  }
};

/**
 * Auto-open active items
 */
var x_terms_init_open_items = () => {

  const activeItems = document.querySelectorAll('.js-terms-navigation .is-active');

  console.log(activeItems);

  for (let i = 0; i < activeItems.length; i++) {
    const item = activeItems[i];
    // item.setAttribute('aria-expanded', 'true');
    let parentNode = item.parentNode;
    while (parentNode && parentNode.nodeName && parentNode.parentNode) {

      if (parentNode.nodeName === 'BUTTON') {
        parentNode.setAttribute('aria-expanded', 'true');
      }
      if (parentNode.nodeName === 'LI') {
        parentNode.classList.add('is-active');
      }
      if (parentNode.nodeName === 'UL') {
        parentNode.setAttribute('aria-hidden', 'false');
      }
      parentNode = parentNode.parentNode;
    }
    var child = item.querySelector('ul');
    var button = item.querySelector('button');
    if (child && button) {
      child.setAttribute('aria-hidden', 'false');
      button.setAttribute('aria-expanded', 'true');
    }
  }

};

// var aucor_terms_menu_auto_open = function(menu) {
//   // Get current term
//   var current_term = menu.querySelector('.terms-navigation__item.current_term');

//   if(current_term != null) {
//     var current_term_parent = current_term.parentNode;
//     var current_term_toggle = current_term.querySelector('.terms-navigation__item__inner button');
//     var current_term_parent_toggle = current_term_parent.parentNode.querySelector('.terms-navigation__item__inner button');

//     console.log(current_term);
//     console.log(current_term_parent);
//     console.log(current_term_toggle);

//     // Opens sub menus under current term parent and all the way top
//     if (!current_term_parent.parentNode.classList.contains('js-terms-navigation')) {
//       current_term_parent.setAttribute('aria-hidden', 'false');
//       current_term_parent_toggle.setAttribute('aria-expanded', 'true');

//     }
//     // Opens sub menu if parent term is current term
//     if (current_term.classList.contains('has_children')) {
//       var current_term_children = current_term.querySelector('.terms-navigation__sub-items');
//       current_term_toggle.setAttribute('aria-expanded', 'true');
//       current_term_children.setAttribute('aria-hidden', 'false');
//     }
//   }
// };

var setup_parents = function(item, relation) {
  var parent_li = item.parentNode.parentNode;
  if (parent_li.nodeName === 'LI') {
    parent_li.classList.add('current_page_' + relation);
    if(parent_li.parentNode.parentNode != null) {
      setup_parents(parent_li, 'ancestor');
    }
  }
};

var aucor_terms_menu_find_and_init = function() {

  // Single product sidebar terms navigation
  var terms_menus = document.querySelectorAll('.js-terms-navigation');
  for (var i = 0; i < terms_menus.length; i++) {
    aucor_terms_menu_init(terms_menus[i], i);
    // aucor_terms_menu_auto_open(terms_menus[i]);
    x_terms_init_open_items();
  }

  // Primary menu "menu-terms" class hook
  var menu_terms_item = document.querySelectorAll('.menu-terms');
  for (var i = 0; i < menu_terms_item.length; i++) {
    var current_term = menu_terms_item[i].querySelector('.current-menu-item');
    if(current_term != null) {
      setup_parents(current_term, 'parent');
    }
  }
};
aucor_terms_menu_find_and_init();
